// Sole Protection Learn More Modal
window.addEventListener("load", function() {
  document.addEventListener("click", function(event) {
    if (event.target.classList.contains("js-sole-protection-learn-trigger")) {
      event.preventDefault();
      var targetHref = event.target.getAttribute("href");
      document.querySelector(targetHref).style.display = 'block';
    }

    if (event.target.classList.contains("js-close-modal")) {
      event.preventDefault();
      var modalParent = event.target.closest(".modal");
      modalParent.style.display = 'none';
    }
  });

  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape") {
      var modal = document.querySelector(".js-sole-protection-learn-modal");
      if (modal) {
        modal.style.display = 'none';
      }
    }
  });
});